import React from 'react';
import PropTypes from 'prop-types';
import WithClickTracking from '../../components/WithClickTracking';
import Article from './Article';
import MoreButton from '../../components/MoreButton';
import DropdownOption from '../../components/DropdownOption';
import { translateResourceString } from '../../../util/translationUtility';
import Facets from '../Facets/Facets';
import PaginationContainer from "../Pagination/PaginationContainer";

class ArticleSearchResultsContainer extends React.Component {
    render() {
        const { articles,
            paginationViewModel,
            onCurrentItemsPerPageChange,
            //onCurrentPageIndexChange,
            onResultClick,
            searchString,
            onToggleFacetExpanded,
            onToggleShowMoreFacet,
            showMoreFacets,
            attributes,
            onAttributeChange,
            expandedArticleFacets,
            onCurrentSortByChange} = this.props;
        const perMoreAmount = 9;
        const nextRequest = Math.min(paginationViewModel.CurrentItemsOnPage + perMoreAmount, paginationViewModel.ResultsTotal);
        const showMore = paginationViewModel.ResultsTotal > paginationViewModel.CurrentItemsOnPage;
        let article_sort_options = [
            new DropdownOption(translateResourceString("/SearchApp/SortOptions/Recency/Display"), 'Recency', translateResourceString("/SearchApp/SortOptions/Recency/FullDisplay")),
            new DropdownOption(translateResourceString("/SearchApp/SortOptions/NameAZ/Display"), 'NameAZ', translateResourceString("/SearchApp/SortOptions/NameAZ/FullDisplay")),
            new DropdownOption(translateResourceString("/SearchApp/SortOptions/NameZA/Display"), 'NameZA', translateResourceString("/SearchApp/SortOptions/NameZA/FullDisplay")),
        ]
        return (
            <div className="">
                <div className="row">
                    <div className="facets-wrapper col-md-4 col-lg-3 mb-1">
                        <Facets
                            attributes={attributes}
                            onAttributeChange={onAttributeChange}
                            expandedFacets={expandedArticleFacets}
                            onToggleFacetExpanded={onToggleFacetExpanded}
                            showMoreFacets={showMoreFacets}
                            onToggleShowMoreFacet={onToggleShowMoreFacet}
                            disableToggle={true}
                        />
                    </div>
                    <div className="article-search-article-item-wrapper col-md-8 col-lg-9">
                    <div className="row">
                        <div className="col-12">
                            <div className="pagination-wrapper">
                                <PaginationContainer
                                    paginationViewModel={paginationViewModel}
                                    attributes={attributes}
                                    onAttributeChange={onAttributeChange}
                                    sortOptions={article_sort_options}
                                    onCurrentSortByChange={onCurrentSortByChange}
                                />
                            </div>
                        </div>
                    </div>
                        <div className="row">
                            <div className="article-list-wrapper col-12 pt-3 pb-3">
                                {articles.map((article, i) => {
                                    return (
                                        <ArticleWithClickTracking {...article} onResultClick={onResultClick} />
                            
                                    );
                                })
                                }
                            </div>
                        </div>
                        {showMore &&
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <a className="btn btn-blue no-arrow color-white"
                                        disabled={false}
                                        onClick={() => onCurrentItemsPerPageChange(nextRequest)}
                                    >
                                        {translateResourceString("/SearchApp/Pagination/Article/LoadMore")}
                                    </a>                                        
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const ArticleWithClickTracking = WithClickTracking(Article);

ArticleSearchResultsContainer.propType = {
    articles: PropTypes.arrayOf(
        PropTypes.shape({
            Title: PropTypes.string,
            Link: PropTypes.string,
            Description: PropTypes.string,
            ImageUrl: PropTypes.string
        })
    ),
    attributes: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        DisplayName: PropTypes.string,
        Values: PropTypes.arrayOf(PropTypes.shape({
            Name: PropTypes.string,
            Checked: PropTypes.bool,
            Count: PropTypes.number
        }))
    })),
    paginationViewModel: PropTypes.shape({
        CurrentPageIndex: PropTypes.number,
        CurrentItemsPerPage: PropTypes.number,
        ResultsTotal: PropTypes.number,
        CurrentItemsOnPage: PropTypes.number,
        CurrentSortBy: PropTypes.string
    }),
    onPerPageChange: PropTypes.func,
    onToggleShowMoreFacet: PropTypes.func,
    showMoreFacets: PropTypes.arrayOf(PropTypes.string),
    onToggleFacetExpanded: PropTypes.func,
    onPageChange: PropTypes.func
};

export default ArticleSearchResultsContainer;
